export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5049.c0db5e02.jpg";